<ngx-ui-loader></ngx-ui-loader>
<p-toast key="main" position="top-center">
    <ng-template let-message pTemplate="message">
      <p innerHtml="{{message.detail}}"></p>
  </ng-template>
  </p-toast>
<router-outlet></router-outlet>
